import React from "react";

export default function CheckboxButton({ value, text, handleClick, icon }) {
	return (
		<button
			className={`button-checkbox ${value ? "checked" : null} ${
				icon ? "button-left-icon" : ""
			}`}
			onClick={handleClick}
		>
			{icon ? <div className="icon">{icon}</div> : null}
			<p className="text">{text}</p>
		</button>
	);
}
